import React from 'react';
import { ScrollArea } from '../ui/scroll-area';
import { ImagePreview } from './ImagePreview';
import { ImageWithPreview } from './types';

interface ImageGridProps {
  images: ImageWithPreview[];
  onRemoveImage: (index: number) => void;
  onUpdateKeywords: (index: number, keywords: string) => void;
}

export const ImageGrid: React.FC<ImageGridProps> = ({
  images,
  onRemoveImage,
  onUpdateKeywords,
}) => {
  if (images.length === 0) return null;

  return (
    <ScrollArea className="h-[500px] rounded-md border p-4">
      <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
        {images.map((image, index) => (
          <ImagePreview
            key={image.preview}
            preview={image.preview}
            keywords={image.keywords}
            onRemove={() => onRemoveImage(index)}
            onKeywordsChange={(keywords) => onUpdateKeywords(index, keywords)}
          />
        ))}
      </div>
    </ScrollArea>
  );
};